module.exports = __webpack_public_path__ + "static/media/99_percent.61e1754a.png";